export default __webpack_public_path__ + "static/media/logoSTech.60414488.png";